import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithAzureAD, getCurrentAccount } from "../azure-auth";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import Header from "../components/Header";

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const account = getCurrentAccount();
    if (account) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleLogin = async () => {
    setLoading(true);
    setError("");

    try {
      const account = await signInWithAzureAD();

      if (account) {
        window.dispatchEvent(new CustomEvent('userLogin', {
          detail: { account }
        }));

        navigate("/dashboard", { replace: true });
      }
    } catch (error) {
      if (!error.message?.includes('user_cancelled')) {
        setError("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />

      {/* ✅ CENTERING WRAPPER */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "calc(100vh - 70px)" // adjust if header height changes
        }}
      >
        {/* ✅ LOGIN BOX */}
        <div
          className="login-container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            background: "rgba(0,0,0,0.7)",
            padding: "40px",
            borderRadius: "12px",
            width: "800px",
            boxShadow: "0 0 20px rgba(0,0,0,0.5)"
          }}
        >
          <img
            src="https://img.freepik.com/premium-psd/happy-robot-3d-ai-character-chat-bot-mascot-gpt-chatbot-icon-artificial-intelligence_95505-482.jpg"
            alt="AI Character"
            style={{
              width: "100px",
              marginBottom: "20px",
              borderRadius: "50%"
            }}
          />

          <h2 style={{ color: "white" }}>Welcome to Agent Store</h2>

          <p
            style={{
              color: '#ccc',
              marginBottom: '25px',
              fontSize: '16px',
              lineHeight: '1.5'
            }}
          >
            Sign in with your Microsoft account to access your assigned AI agents
          </p>

          {error && (
            <div style={{
              color: '#ff6b6b',
              background: 'rgba(255, 107, 107, 0.1)',
              padding: '10px',
              borderRadius: '4px',
              margin: '10px 0',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}

          <button
            onClick={handleLogin}
            disabled={loading}
            style={{
              opacity: loading ? 0.7 : 1,
              cursor: loading ? 'not-allowed' : 'pointer',
              width: '100%',
              maxWidth: '300px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '12px 20px',
              fontSize: '1rem',
              backgroundColor: '#0078d4',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontWeight: '600'
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 23 23"
              fill="currentColor"
              style={{ marginRight: '10px' }}
            >
              <path d="M1 1h10v10H1V1zm11 0h10v10H12V1zM1 12h10v10H1V12zm11 0h10v10H12V12z"/>
            </svg>

            {loading ? 'Signing in...' : 'Sign in with Microsoft'}
          </button>

          <Dialog open={openAlert} onClose={handleCloseAlert}>
            <DialogTitle>Access Denied</DialogTitle>
            <DialogContent>
              <p>{alertMessage}</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseAlert} autoFocus>
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </>
  );
};

export default Login;